/** Ein Rueckläufer: woran er haengt - Korrespondenz oder eingeladener Nutzer - und der Grund im Klartext, nie der Statuscode. */
export class BounceDto {

  public id!: string;

  public reason!: string;

  constructor(init?: Partial<BounceDto>) {
    Object.assign(this, init);
  }

  public getReasonKey(): string {
    return 'correspondence.bounce.reason.' + this.reason.toLowerCase();
  }
}
